__turbopack_context__.v({
  "freeBox__hkAl1": "PlasmicFooter-module__-A4gaa__freeBox__hkAl1",
  "freeBox__hxjdq": "PlasmicFooter-module__-A4gaa__freeBox__hxjdq",
  "freeBox__ztsf2": "PlasmicFooter-module__-A4gaa__freeBox__ztsf2",
  "root": "PlasmicFooter-module__-A4gaa__root",
  "rootglobal_themeOrange_override": "PlasmicFooter-module__-A4gaa__rootglobal_themeOrange_override",
  "rootglobal_themePurpleDark_override": "PlasmicFooter-module__-A4gaa__rootglobal_themePurpleDark_override",
  "svg": "PlasmicFooter-module__-A4gaa__svg",
});
